<template>
  <div class="add">
    <div class="my-chard">
      <!-- 图1 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b>每日新增客户数</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20新增客户数量分析</span>
        <!-- 数字区域 -->
        <div class="mian">
          <!-- 左侧数字 -->
          <div class="lnum">
            <div class="m2">
              <span style="font-size: 14px"> &nbsp7-28 &nbsp&nbsp(三)</span>
              <span style="font-size: 43px; font-weight: bold"
                >319<span style="font-size: 12px;font-weight: 400">人</span>
              </span>
            </div>
            <div class="m3">
              <span style="font-size:12px;"
                >环比
                <span style="color: #ff4343; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #ff4343; font-weight: 600"
                  class="el-icon-top"
                ></i
              ></span>
              <span style="font-size:12px;"
                >同比
                <span style="color: #19e9aa; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #19e9aa; font-weight: 600"
                  class="el-icon-bottom"
                ></i
              ></span>
            </div>
          </div>
          <!-- 右侧数字 -->
          <div class="rnum" style="display:inline-block; transform: translate(45px, 0px);">
            <p class="bigsize">
              <span class="smallsize">合计：</span>31,123<span class="smallsize"
                >人</span
              >
            </p>
            <p class="bigsize">
              <span class="smallsize">均值：</span>31,123<span class="smallsize"
                >人</span
              >
            </p>
          </div>
        </div>
        <div id="a1" style="margin-top: 20px"></div>
      </el-card>
      <!-- 图2 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b>每周新增客户数</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20新增客户数量分析</span>
        <!-- 数字区域 -->
        <div class="mian">
          <!-- 左侧数字 -->
          <div class="lnum">
            <div class="m2">
              <span style="font-size: 14px; font-weight: 500">本周</span>
              <span style="font-size: 43px; font-weight: bold"
                >319<span style="font-size: 12px;font-weight:400;">人</span>
              </span>
            </div>
            <div class="m3">
              <span style="font-size:12px;"
                >环比
                <span style="color: #ff4343; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #ff4343; font-weight: 600"
                  class="el-icon-top"
                ></i
              ></span>
              <span style="font-size:12px;"
                >同比
                <span style="color: #19e9aa; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #19e9aa; font-weight: 600"
                  class="el-icon-bottom"
                ></i
              ></span>
            </div>
          </div>
          <!-- 右侧数字 -->
          <div class="rnum" style="display:inline-block; transform: translate(45px, 0px);">
            <p class="bigsize">
              <span class="smallsize">合计：</span>31,123<span class="smallsize"
                >人</span
              >
            </p>
            <p class="bigsize">
              <span class="smallsize">均值：</span>31,123<span class="smallsize"
                >人</span
              >
            </p>
          </div>
        </div>
        <div id="a2" style="margin-top: 20px"></div>
      </el-card>
      <!-- 图3 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b>每月新增客户数</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20新增客户数量分析</span>
        <!-- 数字区域 -->
        <div class="mian">
          <!-- 左侧数字 -->
          <div class="lnum">
            <div class="m2">
              <span style="font-size: 14px; font-weight: 500">本月</span>
              <span style="font-size: 43px; font-weight: bold"
                >319<span style="font-size: 12px">人</span>
              </span>
            </div>
            <div class="m3">
              <span style="font-size:12px;"
                >环比
                <span style="color: #ff4343; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #ff4343; font-weight: 600"
                  class="el-icon-top"
                ></i
              ></span>
              <span style="font-size:12px;"
                >同比
                <span style="color: #19e9aa; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #19e9aa; font-weight: 600"
                  class="el-icon-bottom"
                ></i
              ></span>
            </div>
          </div>
          <!-- 右侧数字 -->
          <div class="rnum" style="display:inline-block; transform: translate(45px, 0px);">
            <p class="bigsize">
              <span class="smallsize">合计：</span>31,123<span class="smallsize"
                >人</span
              >
            </p>
            <p class="bigsize">
              <span class="smallsize">均值：</span>31,123<span class="smallsize"
                >人</span
              >
            </p>
          </div>
        </div>
        <div id="a3" style="margin-top: 20px"></div>
      </el-card>
      <!-- 图4 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b>新用户下单趋势</b>
        </div>
        <span class="text">7月新客户下单占比</span>
        <!-- 数字日期区域 -->
        <div class="numDate">
          <p class="date" style="font-siez:14px;">7-27 (二)</p>
          <div class="num">
            <div class="left">
              <span class="buleBar"></span><span style="font-siez:14px;">新增用户-没有下单行为</span>
              <p class="blueColor fz43" style="font-weight:bold;">319<span class="fz12" style="font-weight:400;">人</span></p>
            </div>
            <div class="right">
              <span class="greBar"></span><span style="font-siez:14px;">新增用户-有下单行为</span>
              <p class="blueColor fz43" style="font-weight:bold;">319<span class="fz12" style="font-weight:400;">人</span></p>
            </div>
          </div>
        </div>
        <div id="a4" style="margin-top:-20px;"></div>
      </el-card>
      <!-- 图5 -->
      <el-card shadow="never" class="chard-box">
        <div class="top">
          <div class="fl">
            <img
              src="../../../assets/images/newIcon/vipportrait_source_icon@2x.png"
              alt=""
            />
            <span></span><b>新用户来源占比分析</b
            ><span class="text">平台历史用户来源占比</span>
          </div>
        </div>
        <div id="a5"></div>
      </el-card>
      <!-- 图6 -->
      <el-card shadow="never" class="chard-box">
        <div class="top6 clearfix">
          <div class="fl">
            <img
              src="../../../assets/images/newIcon/vipportrait_growth_icon@2x.png"
              alt=""
            />
            <span></span><b>新用户增长趋势</b
            ><span class="text">7月新客户增长趋势</span>
          </div>
          <!-- 右侧区域 -->
          <div class="fr">
            <p>
              <img
                src="../../../assets/images/newIcon/ss_shaixuan_icon.png"
                alt=""
              />
              <el-select
                style="width: 100px"
                v-model="options1.value"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
          </div>
        </div>
        <p style="color: #999999; font-size: 12px; margin-top: 10px">
          7月新客户增长趋势
        </p>
        <div id="a6" style="margin-top: 30px"></div>
      </el-card>
      <!-- 表格 -->
      <el-card shadow="never" class="chard-box my-table">
        <div class="top clear">
          <div class="fl">
            <img
              src="../../../assets/images/newIcon/jimu_vipthing_icon.png"
              alt=""
            />
            <span></span><b>明细表</b
            ><span class="text">各渠道新增用户数据明细</span>
          </div>
          <div class="fr">
            <el-button type="primary" round>
              <img
                style="width: 16px"
                src="../../../assets/images/newIcon/vipportrait_export_icon@2x.png"
                alt=""
              />
              导出</el-button
            >
          </div>
        </div>
        <div class="table-main">
          <el-table :header-cell-style="{background:'#F5F5F5',color:'#333333'}" :data="tableData" style="width: 100%; margin-top: 50px">
            <el-table-column prop="date" label="日期" width="100"> </el-table-column>
            <el-table-column prop="name" label="渠道名称" width="300"> </el-table-column>
            <el-table-column prop="add" label="新增用户数"> </el-table-column>
            <el-table-column prop="pay" label="付费用户数"> </el-table-column>
            <el-table-column prop="cum" label="累计访问用户数">
            </el-table-column>
            <el-table-column prop="GMV" label="GMV"> </el-table-column>
            <el-table-column prop="price" label="客单价"> </el-table-column>
          </el-table>
          <!-- 
            分页组件功能
             @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
           -->
          <el-pagination
            style="margin-top: 30px"
            background
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="  prev, pager, next, sizes,jumper"
            :total="400"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { registerTheme, Chart } from "@antv/g2";
export default {
  data() {
    return {
      options1: [{ name: "一级渠道" }],
      data: [
        { data: "6.21", name: "新增客户数", val: 120 },
        { data: "6.22", name: "新增客户数", val: 750 },
        { data: "6.23", name: "新增客户数", val: 270 },
        { data: "6.24", name: "新增客户数", val: 280 },
        { data: "6.25", name: "新增客户数", val: 850 },
        { data: "6.26", name: "新增客户数", val: 150 },
        { data: "6.27", name: "新增客户数", val: 700 },
        { data: "6.28", name: "新增客户数", val: 140 },
        { data: "6.29", name: "新增客户数", val: 120 },
        { data: "...", name: "新增客户数", val: 130 },
      ],
      data2: [
        { data: "6.21", name: "小程序", val: 120 },
        { data: "6.22", name: "小程序", val: 750 },
        { data: "6.23", name: "小程序", val: 270 },
        { data: "6.24", name: "小程序", val: 280 },
        { data: "6.25", name: "小程序", val: 850 },
        { data: "6.26", name: "小程序", val: 150 },
        { data: "6.27", name: "小程序", val: 700 },
        { data: "6.21", name: "APP", val: 700 },
        { data: "6.22", name: "APP", val: 150 },
        { data: "6.23", name: "APP", val: 850 },
        { data: "6.24", name: "APP", val: 280 },
        { data: "6.25", name: "APP", val: 270 },
        { data: "6.26", name: "APP", val: 750 },
        { data: "6.27", name: "APP", val: 120 },
      ],
      tableData: [
        {
          date: "2018.03.05",
          name: "公众号",
          add: "4,323",
          pay: "100100",
          cum: "100100",
          GMV: "4,3234,323",
          price: "100",
        },
        {
          date: "2018.03.05",
          name: "其他",
          add: "4,323",
          pay: "100",
          cum: "100",
          GMV: "4,323",
          price: "100",
        },
        {
          date: "2018.03.05",
          name: "微信聊天",
          add: "4,323",
          pay: "100",
          cum: "100",
          GMV: "4,323",
          price: "100",
        },
        {
          date: "2018.03.05",
          name: "快捷入口",
          add: "4,323",
          pay: "100",
          cum: "100",
          GMV: "4,323",
          price: "100",
        },
        {
          date: "2018.03.05",
          name: "搜索",
          add: "4,323",
          pay: "100",
          cum: "100",
          GMV: "4,323",
          price: "100",
        },
        {
          date: "2018.03.05",
          name: "公众号",
          add: "4,323",
          pay: "100",
          cum: "100",
          GMV: "4,323",
          price: "100",
        },
        {
          date: "2018.03.05",
          name: "4,323",
          add: "4,323",
          pay: "100",
          cum: "100",
          GMV: "4,323",
          price: "100",
        },
      ],
    };
  },
  mounted() {
    //图一
    this.init("a1", this.data);
    //图2
    this.init("a2", this.data);
    //图3
    this.init("a3", this.data);
    //图4
    this.init3();
    //图5
    this.init2();
    //图6
    this.init(a6, this.data2, 350);
  },
  methods: {
    //线图
    init(id, data, height) {
      const chart = new this.$chart({
        container: id,
        autoFit: true,
        height: height || 300,
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      chart.scale("val", {
        min: 0,
        max: 1000,
      });
      chart.tooltip({
        showCrosshairs: true,
        shared: true,
        showMarkers: true, //移入图表展示圆点
      });
      chart.axis("val", {
        label: {
          formatter: (val) => {
            return val;
          },
        },
      });

      chart.line().position("data*val").shape("smooth").color("name");

      // chart.point().position("data*val").shape("circle");

      chart.render();
    },
    //饼图
    init2() {
      let data = [
        { item: "app", count: 100, percent: 0.35 },
        { item: "小程序", count: 140, percent: 0.65 },
        // { item: "未知", count: 100, percent: 0.33 },
        // { item: '事例四', count: 13, percent: 0.13 },
        // { item: '事例五', count: 9, percent: 0.09 },
      ];

      let chart = new this.$chart({
        container: "a5",
        autoFit: true,
        width: 300,
        height: 400,
      });

      chart.data(data);

      chart.coordinate("theta", {
        radius: 0.65,
      });

      chart.scale("percent", {
        formatter: (val) => {
          val = val * 100 + "%";
          // return val;
        },
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });
      chart.axis(false); // 关闭坐标轴
      const interval = chart
        .interval()
        .adjust("stack")
        .position("percent")
        .color("item", ["#8a98ff", "#ffad77"])
        .label("percent", {
          offset: -40,
          style: {
            textAlign: "center",
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .45)",
            fill: "#fff",
          },
        })
        .tooltip("item*percent", (item, percent) => {
          percent = percent * 100 + "%";
          return {
            name: item,
            value: percent,
          };
        })
        .style({
          lineWidth: 1,
          stroke: "#fff",
        });
      chart.interaction("element-single-selected");
      chart.render();
    },
    //柱线图
    init3() {
      const data1 = [
        { type: "新增用户-没有下单行为", name: "07.01", value: 950 },
        { type: "新增用户-没有下单行为", name: "07.08", value: 288 },
        { type: "新增用户-没有下单行为", name: "07.15", value: 100 },
        { type: "新增用户-没有下单行为", name: "07.22", value: 950 },
        { type: "新增用户-没有下单行为", name: "07.31", value: 1500 },

        { type: "新增用户-有下单行为", name: "07.01", value: 700 },
        { type: "新增用户-有下单行为", name: "07.08", value: 400 },
        { type: "新增用户-有下单行为", name: "07.15", value: 345 },
        { type: "新增用户-有下单行为", name: "07.22", value: 700 },
        { type: "新增用户-有下单行为", name: "07.31", value: 526 },
      ];

      const data2 = [
        { type: "新增用户数", name: "07.01", value: 950 + 730 },
        { type: "新增用户数", name: "07.08", value: 288 + 430 },
        { type: "新增用户数", name: "07.15", value: 100 + 375 },
        { type: "新增用户数", name: "07.22", value: 950 + 730 },
        { type: "新增用户数", name: "07.31", value: 1500 + 556 },
      ];

      const chart = new Chart({
        container: "a4",
        autoFit: true,
        height: 300,
        padding: [25, 20, 25, 20],
      });

      //设置Y轴的最大最小值
      chart.scale("value", {
        min: 0,
        max: 2000,
      });
      const view1 = chart.createView();
      view1.data(data1);
      chart.tooltip({
        shared: true,
        showMarkers: false,
      });
      view1.interval().position("name*value").color("type").adjust("stack");

      const view2 = chart.createView();
      view2.data(data2);
      view2
        .point()
        .position("name*value")
        .shape("circle")
        .color("type", ["#657693"]);
      view2
        .line()
        .position("name*value")
        .shape("dot")
        .color("type", ["#657693"])
        .adjust("stack");

      chart.legend({
        custom: true,
        items: [
          {
            name: "新增用户-没有下单行为",
            id: "new",
            marker: { symbol: "square", style: { fill: "#5B6FF9" } },
          },
          {
            name: "新增用户-有下单行为",
            id: "old",
            marker: { symbol: "square", style: { fill: "#44D7B6" } },
          },
          {
            name: "新增用户数",
            id: "sum",
            marker: { symbol: "square", style: { fill: "#657693" } },
          },
        ],
      });

      chart.render();
    },
  },
};
</script>

<style lang="less">
.add {
  .bigsize {
    font-size: 28px;
    font-weight: 500;
  }
  .smallsize {
    font-size: 12px;
    font-weight: normal;
  }
  .my-chard {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .chard-box {
      margin-top: 20px;
      width: 49%;
      height: 480px;
      // 顶部文字样式
      .fl {
        font-size: 16px;
        display: flex;
        align-items: center;
        b {
          margin-left: 10px;
        }
        img {
          width: 24px;
        }
      }
      .text {
        display: block;
        margin-left: 12px;
        color: #333;
        font-size: 12px;
        line-height: 24px;
        margin-top: 10px;
      }
      //数字样式
      .mian {
        display: flex;
        justify-content: space-between;
        .lnum {
          display: flex;
          .m2 {
            margin-left: 20px;
            margin-bottom: -5px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            color: #0091ff;
          }
          .m3 {
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }
        }
        .rnum {
          margin-right: 60px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &:after {
            content: "";
            width: 2px;
            height: 40px;
            background-color: #333;
            position: absolute;
            top: 16px;
            left: -20px;
          }
        }
      }
      // 图4单独样式部分
      .numDate {
        margin-top: 10px;
        margin-left: 13px;
        .date {
          color: #327eff;
        }
        .num {
          display: flex;
          justify-content: space-between;
          .right {
            margin-right: 60px;
          }
        }
      }
      //图5单独样式部分
      .top {
        .fl {
          font-size: 16px;
          display: flex;
          float: left;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
          .text {
            margin-left: 12px;
            color: #333;
            font-size: 12px;
            line-height: 24px;
          }
        }
        .fr {
          float: right;
        }
      }
      //图6单独样式部分
      .top6 {
        margin-top: -5px;
        .fl {
          float: left;
          font-size: 16px;
          display: flex;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
          .text {
            margin-left: 12px;
            color: #333;
            font-size: 12px;
            line-height: 24px;
          }
        }
        .fr {
          float: right;
          color: #999999;
          font-size: 12px;
          p {
            img {
              width: 16px;
              vertical-align: middle;
              //   margin-right: 10px;
            }
          }
          .my-select {
            margin-left: 10px;
          }
        }
      }
    }
    //表格单独样式
    .my-table {
      width: 98%;
      height: 550px;
      .el-table{
        border: none;
      }
      .cell{
        font-size: 12px;
        text-align: center;
      }
      .el-table__row {
        height: 53px;
      }
    }
  }
  .buleBar,
  .greBar {
    display: inline-block;
    width: 4px;
    height: 13px;
    background-color: #327eff;
    border-radius: 2px;
    margin-right: 10px;
  }
  .greBar {
    background-color: #73deb3;
  }
  .blueColor {
    color: #327eff;
  }
  .fz43 {
    font-size: 43px;
  }
  .fz12 {
    font-size: 12px;
  }
}
</style>